import Filter from '@alltrails/shared/icons/Filter';
import { COLOR_INTERACTIVE_PRIMARY } from '@alltrails/shared/denali/tokens';
import { CopyToListsButton } from 'react_components/main_action_bar/copy_to_lists_button';
import CustomProvider from 'components/CustomProvider';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { useIntl } from '@alltrails/shared/react-intl';
import ShareObject from 'types/ShareObject';
import * as styles from './styles/styles.module.scss';
import ActionBarItem from '../ActionBarItem';
import SharePopupButton from '../SharePopupButton/SharePopupButton';

type List = {
  id: number;
  list_id: number;
  user_id: number;
};

type Props = {
  explorePath: string;
  shareObject: ShareObject;
  list: List;
};

function ListActionBar({ explorePath, list, shareObject }: Props) {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        <ActionBarItem
          title={intl.formatMessage({ defaultMessage: 'Filter' })}
          href={explorePath}
          icon={<Filter color={COLOR_INTERACTIVE_PRIMARY} />}
          testId="filter-action"
        />
        <CopyToListsButton
          listId={list.list_id}
          currentUser={user}
          disabled={user && user.id === list.user_id}
          languageRegionCode={languageRegionCode}
          intl={intl}
        />
        {!__AT_DATA__.mobileBrowser && <SharePopupButton shareObject={shareObject} />}
      </ul>
    </div>
  );
}

export default function ListActionBarWrapper({ explorePath, list, shareObject }: Props) {
  return (
    <CustomProvider>
      <ListActionBar explorePath={explorePath} list={list} shareObject={shareObject} />
    </CustomProvider>
  );
}
